import _ from 'lodash';
import React, { Component } from 'react';
import DecoratorConstants from '../../utils/DecoratorConstants';
import Time from '../../utils/Moment';
import Routes from '../../utils/Routes';
import DataTable from './DataTable';
import MTableColumnDataMapping from './models/MTableColumnDataMapping';

class ExecutionTestResultTestObjectDataTable extends Component {
  render() {
    const headers = [
      new MTableColumnDataMapping(
        'ID',
        'testObjectEntity.id',
        (name, row) => {
          const routes = new Routes({
            testObjectEntityId: row.testObjectEntity.id,
          });
          return DecoratorConstants.idDecorator(name, row, routes.test_object_entity_details_link);
        }
      ),
      new MTableColumnDataMapping(
        'Name',
        'testObjectEntity.name',
      ),
      new MTableColumnDataMapping(
        'Timestamp',
        'startTime',
        (name, row) => Time.format(_.get(row, name), Time.DF_DATE_FORMAT)
      )
    ];
    return (
      <DataTable
        entityType="ExecutionTestResultTestObjectEntity"
        tableId="ExecutionTestResultTestObjectEntity"
        columnMapping={headers}
        defaultSort={['startTime,asc']}
        {...this.props}
      />
    );
  }
}

export default ExecutionTestResultTestObjectDataTable;
